<header
  class="tracking-page-header visual-builder-block no-border-spacing"
  #header
  *ngIf="
    trackingPage?.logo?.on ||
    trackingPage?.searchButton?.on ||
    trackingPage?.socialIcons?.icons.length > 0 ||
    trackingPage?.languageMenu?.on
  "
  [ngStyle]="{
    backgroundColor: trackingPage?.header?.backgroundColor || '#fff'
  }"
  [class.selected]="selectedId?.id === 'header'"
  (click)="onHeaderClick($event, header, nav, container)"
>
  <div
    #container
    class="container-fluid"
    [class.container]="!noSidebar"
    [class.container-min]="noSidebar"
  >
    <nav
      #nav
      class="navbar flex align-center justify-between visual-builder-block"
      [class.pl-0]="!noSidebar"
      [class.pr-0]="!noSidebar"
    >
      <div
        class="tracking-page-header__burger"
        *ngIf="!noSidebarButton && !searchPage"
      >
        <button
          class="btn btn-transp btn-search-dop tracking-page-header__burger-btn mb-0"
          [ngStyle]="
            trackingPage.searchButton
              | fontFamily : 'color'
              | assign : searchButtonStyles
          "
          (click)="toggleSidebar.emit()"
        >
          <i class="icons icon-ic_1"></i>
        </button>
      </div>
      <div class="flex align-center">
        <div class="media tracking-page-header__logo-wrapper">
          <div
            class="visual-builder-block"
            *ngIf="trackingPage?.logo?.on"
            [class.selected]="selectedId?.id === 'logo'"
            (click)="selectBlock.emit('logo')"
          >
            <a
              *ngIf="trackingPage?.logo?.linkUrl; else noHref"
              [href]="trackingPage?.logo?.linkUrl"
              target="_blank"
              (click)="onAnchorClick($event)"
            >
              <img
                class="tracking-page-header__logo"
                [attr.src]="logo || trackingPage?.logo?.imageUrl"
                alt="Logo"
              />
            </a>
            <ng-template #noHref>
              <img
                class="tracking-page-header__logo"
                [attr.src]="logo || trackingPage?.logo?.imageUrl"
                alt="Logo"
              />
            </ng-template>
          </div>
        </div>
      </div>
      <div
        [ngStyle]="{
          'justify-content': trackingPage?.socialIcons?.alignment || 'left'
        }"
        class="social-ions-desktop ml-2 visual-builder-block tracking-page-icons"
        [class.selected]="selectedId?.id === 'socialIcons'"
        (click)="selectBlock.emit('socialIcons')"
      >
        <div
          [ngStyle]="marginStyles"
          class="social-icon-link"
          *ngFor="let icon of trackingPage?.socialIcons?.icons"
        >
          <a
            class="fs-20"
            target="_blank"
            [attr.href]="icon.url?.length ? icon.url : null"
            [style.color]="trackingPage?.socialIcons?.fontColor"
            (click)="onAnchorClick($event)"
          >
            <i class="fa-brands" [ngClass]="icon.icon"></i>
          </a>
        </div>
      </div>
      <div
        class="form-inline tracking-page-header__search-button"
        *ngIf="!isMobile || trackingPage?.searchButton?.on"
      >
        <ng-container *ngIf="!isMobile && trackingPage?.languageMenu?.on">
          <app-tracking-page-language-menu
            [languageMenu]="trackingPage.languageMenu"
            [selectedId]="selectedId"
            [isVisualBuilder]="isVisualBuilder"
            [isMobile]="isMobile"
            (changeLanguage)="changeLanguage.emit($event)"
            (selectBlock)="selectBlock.emit($event)"
          ></app-tracking-page-language-menu>
        </ng-container>

        <div *ngIf="trackingPage?.searchButton?.on && !searchPage">
          <div>
            <button
              class="btn btn-transp btn-search btn-search-dop mb-0"
              type="button"
              (click)="backToSearch()"
              *ngIf="!preventNavigation; else noNavigation"
              [ngStyle]="
                trackingPage.searchButton
                  | fontFamily
                  | assign : searchButtonStyles
              "
            >
              <span class="d-none d-sm-block">{{
                'search_button' | translate
              }}</span>
              <i
                class="icon-ic_27 fs-24 d-block d-sm-none"
                style="width: 24px; height: 24px"
              ></i>
            </button>
          </div>
          <ng-template #noNavigation>
            <div
              [class.selected]="selectedId?.id?.includes('searchButton')"
              class="visual-builder-block"
            >
              <button
                class="btn btn-transp btn-search btn-search-dop mb-0 visual-builder-block"
                type="button"
                [ngStyle]="
                  trackingPage.searchButton
                    | fontFamily
                    | assign : searchButtonStyles
                "
                (click)="selectBlock.emit('searchButton')"
              >
                <span (click)="onSearchClick.emit()">
                  <span class="d-none d-sm-block">{{
                    'search_button' | translate
                  }}</span>
                  <i
                    class="icon-ic_27 fs-24 d-block d-sm-none"
                    [ngStyle]="trackingPage.searchButton | fontFamily : 'color'"
                  ></i>
                </span>
              </button>
            </div>
          </ng-template>
        </div>
      </div>
    </nav>
    <div class="d-flex align-center mobile-language-container">
      <div
        [ngStyle]="{
          'justify-content': trackingPage?.socialIcons?.alignment || 'left'
        }"
        class="social-icons-mobile visual-builder-block"
        [class.selected]="selectedId?.id === 'socialIcons'"
        (click)="selectBlock.emit('socialIcons')"
      >
        <div
          [ngStyle]="marginStyles"
          *ngFor="let icon of trackingPage?.socialIcons?.icons"
          class="social-icon-link"
        >
          <a
            class="fs-20"
            target="_blank"
            [attr.href]="icon.url"
            [style.color]="trackingPage?.socialIcons?.fontColor"
            (click)="onAnchorClick($event)"
          >
            <i class="fa-brands" [ngClass]="icon.icon"></i>
          </a>
        </div>
      </div>
      <ng-container *ngIf="isMobile && trackingPage?.languageMenu?.on">
        <app-tracking-page-language-menu
          [languageMenu]="trackingPage.languageMenu"
          [selectedId]="selectedId"
          [isVisualBuilder]="isVisualBuilder"
          [isMobile]="isMobile"
          (changeLanguage)="changeLanguage.emit($event)"
          (selectBlock)="selectBlock.emit($event)"
        ></app-tracking-page-language-menu>
      </ng-container>
    </div>
  </div>
</header>
